import { createFileRoute } from '@tanstack/react-router'
import { BudgetPage } from '@/features/budget/budget-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/budget')({
  component: BudgetRoute,
})

function BudgetRoute() {
  const { workspaceSlug } = Route.useParams()

  return <BudgetPage workspaceSlug={workspaceSlug} />
}
